"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation generateEventQRCode($eventId: String) {
    generateEventQRCode(eventId: $eventId)
  }
`;
exports.default = mutation;
//# sourceMappingURL=generateEventQRCode.mutation.js.map